import { NgModule }      from '@angular/core';
import { DataService }   from '../';


@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ DataService ],
  exports:      [ ],
})

export class ApiDataModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/data/module/api.data.module.ts